import { siteInfo } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-fire-line"></i>
              <span>2026暑期档热映中</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight tracking-tight text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              91在线视频
              <br />
              <span className="text-primary-600">国产影视资源聚合平台</span>
            </h1>

            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#carousel"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium text-sm rounded-lg border border-background-300/60 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line text-lg"></i>
                浏览合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-200/20 to-primary-100/30 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20film%20scene%2C%20warm%20ambient%20lighting%2C%20cozy%20living%20room%2C%20red%20and%20gold%20decor%20accents%2C%20movie%20posters%20on%20wall%2C%20premium%20entertainment%20experience%2C%20soft%20glow%2C%20inviting%20atmosphere%2C%20editorial%20photography%20style&width=700&height=500&seq=hero-main&orientation=landscape"
                alt="91在线视频 - 国产影视高清观影体验"
                className="relative w-full h-auto rounded-2xl object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    const placeholder = parent.querySelector('.img-placeholder');
                    if (placeholder) (placeholder as HTMLElement).style.display = 'flex';
                  }
                }}
              />
              <div className="img-placeholder hidden w-full aspect-[7/5] bg-background-200 rounded-2xl flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-movie-line text-4xl text-foreground-400"></i>
                  <p className="mt-2 text-sm text-foreground-500">91在线视频</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}